// extracted by mini-css-extract-plugin
module.exports = {"container":"container--jM7T7","tip1":"tip1--bT9DP","tip2":"tip2--lq9Im","emptyImg":"emptyImg--sEZPM"};